import { FC } from 'react';
import { SvgIconProps } from '@mui/material';

export enum IconKey {}

export const Icon: Record<IconKey, FC<SvgIconProps>> = {};
